"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const react_1 = __importDefault(require("react"));
const alert_constants_1 = require("./alert.constants");
const alert_styles_1 = require("./alert.styles");
const Alert = (props) => react_1.default.createElement(alert_styles_1.StyledAlert, Object.assign(Object.assign({ variant: "outlined" }, props), { iconMapping: alert_constants_1.ICON_MAPPING }));
exports.Alert = Alert;
exports.default = exports.Alert;
